import React, { useState } from 'react';
import Footter from '../Component/footter';
import WhatsAppContact from '../Component/joinNowComponent/whatsAppContact';
import Step1 from '../Component/joinNowComponent/step1';
import Stepper from '@mui/joy/Stepper';
import Step from '@mui/joy/Step';
import StepIndicator from '@mui/joy/StepIndicator';
import Check from '@mui/icons-material/Check';
import { useJoinNowContext } from '../Context/joinNowContext';
import PersonalInformation from '../Component/joinNowComponent/personalInformation';
import ChoseMemberShip from '../Component/joinNowComponent/choseMemberShip';
import OtpVerfication from '../Component/joinNowComponent/otpVerfication';
import LastStep from '../Component/joinNowComponent/lastStep';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ContactMethod from '../Component/joinNowComponent/ContactMethod';
import EmailContact from '../Component/joinNowComponent/EmailContact';

function JoinNow() {
    const [selected, setSelected] = useState<string | null>("I want to join");
    const { step, setStep , selectContact } = useJoinNowContext()
    const handleChange = (value: string) => {
        setSelected(value);
        setStep(0)
    };



    const steps = ['', '', '', "", ""];
    return (
        <div className="w-full h-full bg-[#1c1c1c] item-center justify-center flex flex-col">
            {step!==0 && step!==4 && <div
                className="flex ml-[20px] mt-[10px] sm:absolute sm:top-[5%] sm:left-[5%] items-center cursor-pointer  "
                onClick={() => (step !== 0 ? setStep(step - 1) : "")}
            >
                <KeyboardBackspaceIcon sx={{ color: "white" }} />
                <span className="text-white">Back</span>
            </div>}

            <div className="w-[96%] lg:w-[65%] m-auto h-auto bg-inherit item-center justify-center md:p-10 text-center font-montserrat">
                <div className="flex text-center mt-10 flex flex-col ">
                    <h1 className="text-red font-semibold text-xl sm:text2xl md:text-3xl ">
                        Join Fit Streak Today
                    </h1>
                    <h1 className="text-white font-semibold text-xl sm:text-2xl md:text-4xl ">
                        Your fitness journey starts here
                    </h1>
                </div>
                <div className="flex space-x-2 xss:space-x-4 sm:space-x-10 mt-20 justify-center">
                    {/* Radio Button 1 */}
                    <div
                        className="px-2 py-2 sm:px-4 md:px-8 flex flex-row space-x-2 xss:space-x-4 xxs:space-x-1 item-center rounded-[4px] bg-[#303030] cursor-pointer"
                        onClick={() => handleChange('I want to join')}
                    >
                        <label htmlFor="radio1" className="relative inline-flex space-x-2 xss:space-x-4 xxs:space-x-1 items-center cursor-pointer">
                            <input
                                type="radio"
                                id="radio1"
                                name="radio-group"
                                value="I want to join"
                                checked={selected === 'I want to join'}
                                onChange={() => handleChange('I want to join')}
                                className="hidden peer"
                            />
                            <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 peer-checked:border-red peer-checked:bg-red">
                                {/* Checkmark Icon */}
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`w-3 h-3 text-white ${selected === "I want to join" ? "block" : "hidden"} transition-opacity duration-200`}
                                    viewBox="0 0 20 20"
                                    style={{ fill: '#fff' }}
                                >
                                    <g data-name="Group 24954">
                                        <path
                                            data-name="Path 68503"
                                            d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                                            transform="translate(-4.373 -3.52)"
                                        />
                                    </g>
                                </svg>
                            </span>
                            <h1 className="text-white xxs:text-xs text-sm sm:text-base md:text-lg">I want to join</h1>
                        </label>
                    </div>

                    {/* Radio Button 2 */}
                    <div
                        className="px-2 py-2 sm:px-4 md:px-8 flex flex-row space-x-2 xss:space-x-4 xxs:space-x-1 rounded-[4px] bg-[#303030] cursor-pointer"
                        onClick={() => handleChange('Speak to Someone')}
                    >
                        <label htmlFor="radio2" className="relative space-x-2 xss:space-x-4 xxs:space-x-1 inline-flex items-center cursor-pointer">
                            <input
                                type="radio"
                                id="radio2"
                                name="radio-group"
                                value="Speak to Someone"
                                checked={selected === 'Speak to Someone'}
                                onChange={() => handleChange('Speak to Someone')}
                                className="hidden peer"
                            />
                            <span className="w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 peer-checked:border-red peer-checked:bg-red">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className={`w-3 h-3 text-white ${selected === "Speak to Someone" ? "block" : "hidden"} transition-opacity duration-200`}
                                    viewBox="0 0 20 20"
                                    style={{ fill: '#fff' }}
                                >
                                    <g data-name="Group 24954">
                                        <path
                                            data-name="Path 68503"
                                            d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                                            transform="translate(-4.373 -3.52)"
                                        />
                                    </g>
                                </svg>
                            </span>
                            <h1 className="text-white xxs:text-xs text-sm sm:text-base md:text-lg">Speak to Someone</h1>
                        </label>
                    </div>
                </div>
                {selected ==='I want to join' && <div className='text-[#bbbbbb] flex text-center mt-10 flex flex-col'>
                    <h1 className=' font-semibold xxs:text-[0.7rem] text-xs  sm:text-base xl:text-lg'>Follow the steps below to begin your journey with us</h1>
                </div>}
                {selected === 'I want to join' && <div className='w-[80%] sm:w-[500px] mt-10 mb-10 md:w-[600px] m-auto item-center justify-center relative  ' >
                    <Stepper sx={{ width: '100%' }}>
                        {steps.map((data, index) => (
                            <Step
                                key={index}
                                indicator={
                                    <StepIndicator
                                        variant={'solid'}
                                        sx={{
                                            bgcolor: step < index ? '#303030' : '#e31c25', // Black for completed, red for danger
                                            color: '#fff', // White text color
                                            border: '2px solid white', // White border around the circle
                                            fontSize: "12px"
                                        }}
                                    >
                                        {step <= index ? index + 1 : <Check sx={{ fontSize: "13px" }} />}
                                    </StepIndicator>
                                }
                                sx={[
                                    step > index &&
                                    index !== 5 && { '&::after': { bgcolor: '#e31c25' } },
                                ]}
                            >
                            </Step>
                        ))}
                    </Stepper>
                </div>}
                {selected === 'I want to join' && (
                    <div>
                        <div>{step === 0 && <Step1 />} </div>
                        <div>{step === 1 && <PersonalInformation />} </div>
                        <div>{step === 3 && <OtpVerfication />}</div>
                        <div>{step === 4 && <LastStep />}</div>
                    </div>)
                }
                {selected === 'Speak to Someone' && (
                    <div>
                        <div>{step === 0 && <ContactMethod />} </div>
                        {(selectContact==="Mobile Number" && step===1) && (<div> <WhatsAppContact /> </div>)}     
                        {(selectContact==="Send Email" && step===1) && (<div> <EmailContact /> </div>)}                                             
                    </div>)
                }
            </div>
            {selected === 'I want to join' && (<div className='mb-10'>{step === 2 && <ChoseMemberShip />} </div>)}
            <div className="w-full h-auto bg-[#161616] aling-center flex relative z-20">
                <Footter />
            </div>
        </div>
    );
}

export default JoinNow;
